/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const OnAirIcon = ({ width = 24, height = 24, hidden = false, title = 'On Air' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M21.812 18.678a.5.5 0 0 0-.107.678l.574.823a.5.5 0 0 0 .716.115 8 8 0 1 0-9.971.015.5.5 0 0 0 .718-.117l.571-.824a.5.5 0 0 0-.109-.679 6 6 0 0 1 5.26-10.471 5.913 5.913 0 0 1 3.991 3.3 6.02 6.02 0 0 1-1.643 7.16Z"
    />
    <path
      d="M16.419 1.094a13 13 0 0 0-6.244 23.288.508.508 0 0 0 .717-.122l.569-.821a.5.5 0 0 0-.116-.681 11 11 0 1 1 13.337-.019.5.5 0 0 0-.115.68l.573.821a.506.506 0 0 0 .715.119 13 13 0 0 0-9.436-23.265Z"
    />
    <path
      d="M19.4 17.2a3.5 3.5 0 1 0-2.809 0L11.75 33.356a.5.5 0 0 0 .479.644h1.043a.5.5 0 0 0 .479-.356L15.443 28h5.113l1.693 5.644a.5.5 0 0 0 .479.356h1.043a.5.5 0 0 0 .479-.644ZM16 14a2 2 0 1 1 2 2 2 2 0 0 1-2-2Zm.043 12L18 19.477 19.957 26Z"
    />
  </svg>`;
};
